import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, FileText, ClipboardList } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './BrandingSystem';
interface CTAScreenProps {
  onShowDisclaimer?: () => void;
  onShowPrescribingInfo?: () => void;
}
export function CTAScreen({
  onShowDisclaimer,
  onShowPrescribingInfo
}: CTAScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="w-full max-w-3xl mx-auto bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-1">
      <div className="flex flex-row" data-id="element-2">
        {/* Image side */}
        <div className="w-2/5 shrink-0" data-id="element-3">
          <img src="https://cdn.magicpatterns.com/uploads/mcCG9XrcPtq1X6dFkwxde1/Screenshot_2026-02-12_at_07.45.03.png" alt="Healing everyday heroes, together — women celebrating on a football pitch" className="w-full h-full object-cover" data-id="element-4" />
        </div>

        {/* Content side */}
        <div className="flex-1 flex flex-col justify-between p-5 md:p-6" data-id="element-5">
          <div data-id="element-6">
            <h2 className="text-xl md:text-2xl font-bold text-brand-primary mb-5" data-id="element-7">
              Flexible. Recommended. Accessible.
            </h2>

            <div className="flex flex-col gap-2.5" data-id="element-8">
              <Button variant="primary" onClick={() => window.open('https://gskpro.com/en-caricam/products/augmentin/', '_blank')} data-id="element-9">
                Explore Augmentin <ArrowRight className="w-4 h-4 ml-2 inline" data-id="element-10" />
              </Button>

              <div className="flex items-center gap-2 flex-wrap" data-id="element-11">
                <button onClick={onShowPrescribingInfo} className="inline-flex items-center gap-1.5 px-3 py-2 text-[10px] font-semibold text-gray-500 bg-gray-100 rounded-lg border border-gray-200 hover:bg-gray-200 hover:text-gray-700 transition-colors" data-id="element-12">
                  <ClipboardList className="w-3 h-3" data-id="element-13" />
                  Prescribing Information
                </button>

                <button onClick={onShowDisclaimer} className="inline-flex items-center gap-1.5 px-3 py-2 text-[10px] font-semibold text-gray-500 bg-gray-100 rounded-lg border border-gray-200 hover:bg-gray-200 hover:text-gray-700 transition-colors" data-id="element-14">
                  <FileText className="w-3 h-3" data-id="element-15" />
                  Legal Disclaimer
                </button>
              </div>
            </div>
          </div>

          {/* QR Code */}
          <div className="flex items-center gap-2.5 mt-4 pt-3 border-t border-gray-100" data-id="element-16">
            <div className="w-14 h-14 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center text-gray-400 shrink-0" data-id="element-17">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-18">
                <rect x="2" y="2" width="6" height="6" data-id="element-19" />
                <rect x="16" y="2" width="6" height="6" data-id="element-20" />
                <rect x="2" y="16" width="6" height="6" data-id="element-21" />
                <rect x="16" y="16" width="4" height="4" data-id="element-22" />
                <rect x="10" y="2" width="4" height="4" data-id="element-23" />
                <rect x="2" y="10" width="4" height="4" data-id="element-24" />
                <rect x="10" y="10" width="4" height="4" data-id="element-25" />
                <line x1="22" y1="14" x2="22" y2="22" data-id="element-26" />
                <line x1="14" y1="22" x2="22" y2="22" data-id="element-27" />
              </svg>
            </div>
            <p className="text-[10px] text-gray-400 leading-tight" data-id="element-28">
              Scan QR code for
              <br data-id="element-29" />
              more information
            </p>
          </div>
        </div>
      </div>
    </motion.div>;
}